'use strict';
require('../../modules/es.string.pad-start');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'padStart');
